import { useEffect, useState } from 'react';
import './styles/admin.scss';
import { ApiHelper } from '../../apiHelper/ApiHelper';
import { useConfirm } from '../../components/admin/useConfirm';

type Slot = { id: string; start: string; durationMinutes: number; meetUrl: string; bookedByName?: string | null; bookedByEmail?: string | null };
const emptyForm = { start: "", durationMinutes: 60, meetUrl: "" };

function fmt(d: string) { const x = new Date(d); return x.toLocaleString("cs-CZ", { day: "numeric", month: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit" }); }

export default function AdminOnline() {
    const [slots, setSlots] = useState<Slot[]>([]);
    const [loaded, setLoaded] = useState(false);
    const [form, setForm] = useState({ ...emptyForm });
    const api = new ApiHelper();
    const { ask, confirmModal } = useConfirm();

    useEffect(() => { load(); }, []);

    async function load() {
        try { setSlots(await (await api.adminOnlineApi.slots()).json()); } catch (x: any) { api.adminError(x); } finally { setLoaded(true); }
    }
    async function create() {
        if (!form.start) { api.alert.error("Zadej datum a čas"); return; }
        try { await api.adminOnlineApi.createSlot({ start: form.start, durationMinutes: Number(form.durationMinutes), meetUrl: form.meetUrl.trim() }); api.alert.success("Slot vytvořen"); setForm({ ...emptyForm }); await load(); } catch (x: any) { api.adminError(x); }
    }
    function del(s: Slot) { ask(<>Smazat volný termín {fmt(s.start)}?</>, async () => { try { await api.adminOnlineApi.deleteSlot(s.id); await load(); } catch (x: any) { api.adminError(x); } }); }

    return (
        <div>
            <div className="adminHead">
                <div><h1>Online lekce</h1><p>Individuální termíny lektora a jejich rezervace</p></div>
            </div>

            <div className="aCard" style={{ marginBottom: "18px" }}>
                <h2>Nový termín</h2>
                <div className="lessonForm">
                    <div className="aField inline"><label>Datum a čas</label><input type="datetime-local" value={form.start} onChange={e => setForm({ ...form, start: e.target.value })} /></div>
                    <div className="aField inline"><label>Délka (min)</label><input type="number" min={1} value={form.durationMinutes} onChange={e => setForm({ ...form, durationMinutes: Number(e.target.value) })} /></div>
                    <div className="aField inline"><label>Meet URL</label><input placeholder="prázdné = automatický Jitsi odkaz" value={form.meetUrl} onChange={e => setForm({ ...form, meetUrl: e.target.value })} /></div>
                    <button className="aBtn" onClick={create}>+ Vytvořit termín</button>
                </div>
            </div>

            <table className="aTable">
                <thead><tr><th>Termín</th><th>Délka</th><th>Rezervace</th><th></th></tr></thead>
                <tbody>
                    {slots.map(s => (
                        <tr key={s.id}>
                            <td>{fmt(s.start)}</td>
                            <td>{s.durationMinutes} min</td>
                            <td>{s.bookedByEmail ? <span>{s.bookedByName || ""} <span className="muted">{s.bookedByEmail}</span></span> : <span className="muted">volný</span>}</td>
                            <td>{s.bookedByEmail ? <span className="muted">—</span> : <span className="x" onClick={() => del(s)}>×</span>}</td>
                        </tr>
                    ))}
                    {loaded && slots.length === 0 && <tr><td colSpan={4} className="muted">Žádné termíny.</td></tr>}
                </tbody>
            </table>
            {confirmModal}
        </div>
    );
}
